import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issueHiddenTitle: {
		id: 'backlog.flags.card-create-filtered-v2.issue-hidden-title',
		defaultMessage: 'Changes are saved, but the issue isn’t visible',
		description: 'Created but filtered issue flag title',
	},
	issueHiddenDescription: {
		id: 'backlog.flags.card-create-filtered-v2.issue-hidden-description',
		defaultMessage: 'Issue {linkStart}{linkEnd} is currently hidden by a filter.',
		description: 'Created but filtered issue flag title',
	},
	issueLink: {
		id: 'backlog.flags.card-create-filtered-v2.issue-link',
		defaultMessage: 'View issue',
		description: 'Link to the issue',
	},
	multipleIssuesHiddenTitle: {
		id: 'backlog.flags.card-create-filtered-v2.multiple-issues-hidden-title',
		defaultMessage: "Changes are saved, but issues aren't visible",
		description: 'Created but filtered multiple issues flag title',
	},
	multipleIssuesHiddenDescription: {
		id: 'backlog.flags.card-create-filtered-v2.multiple-issues-hidden-description',
		defaultMessage: 'Created issues are currently hidden by a filter.',
		description: 'Created but filtered multiple issues flag description',
	},
	settingsLink: {
		id: 'backlog.flags.card-create-filtered-v2.settings-link',
		defaultMessage: 'Manage custom filters',
		description: 'Link to custom filters settings',
	},
	issueHiddenTitleIssueTermRefresh: {
		id: 'backlog.flags.card-create-filtered-v2.issue-hidden-title-issue-term-refresh',
		defaultMessage: 'Changes are saved, but the work item isn’t visible',
		description: 'Created but filtered issue flag title',
	},
	issueHiddenDescriptionIssueTermRefresh: {
		id: 'backlog.flags.card-create-filtered-v2.issue-hidden-description-issue-term-refresh',
		defaultMessage: 'Work item {linkStart}{linkEnd} is currently hidden by a filter.',
		description: 'Created but filtered issue flag title',
	},
	issueLinkIssueTermRefresh: {
		id: 'backlog.flags.card-create-filtered-v2.issue-link-issue-term-refresh',
		defaultMessage: 'View work item',
		description: 'Link to the issue',
	},
	multipleIssuesHiddenTitleIssueTermRefresh: {
		id: 'backlog.flags.card-create-filtered-v2.multiple-issues-hidden-title-issue-term-refresh',
		defaultMessage: 'Changes are saved, but nothing is visible',
		description: 'Created but filtered multiple issues flag title',
	},
	multipleIssuesHiddenDescriptionIssueTermRefresh: {
		id: 'backlog.flags.card-create-filtered-v2.multiple-issues-hidden-description-issue-term-refresh',
		defaultMessage: 'New work items are currently hidden by a filter.',
		description: 'Created but filtered multiple issues flag description',
	},
});
